// extracted by mini-css-extract-plugin
export default {"link":"FeedbackLink-module__link--uY6Kq"};